export default __webpack_public_path__ + "static/media/cube_blue.bbeda3e5.png";